export const CAMERA_MODE_PROP = {
  USER: 'user',
  ENVIRONMENT: 'environment',
};

export const TYPE_PHOTO_ID = {
  FRONT: 4,
  BACK: 5,
  SELFIE: 6,
  VIDEO: 8,
};

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
};

export const CONTACT = {
  PHONE: 'phone',
  EMAIL: 'email',
};

export const CAPTURE_BEHAVIOUR = {
  STEP1: 'registration-1',
  STEP2: 'registration-2',
  STEP3: 'registration-3',
  STEP4: 'registration-4',
};

export const lang = Object.freeze({
  ru: 'ru',
  kg: 'kg',
});

export const PAYMENT_METHOD = Object.freeze({
  E_WALLET: 'wallet',
});

export const BooleanEnum = {
  true: 1,
  false: 0,
};

export const zeroAmount = 0;

export const COUNTRY_PHONE_CODE = '0';
export const MOBILE_PHONE_LENGTH = 10;
export const EMAIL_CODE_LENGTH = 5;
export const SMS_CODE_LENGTH = 4;
export const SOCIAL_FUND_OTP_CODE_LENGTH = 6;
export const PHONE_CODE_LENGTH = 4;
export const MONITOR_TIMEOUT_MS = 1000;
export const GET_APPLICATION_TIMEOUT_S = 10;
export const E_WALLET_NUMBER_LENGTH = 10;
export const SEND_SMS_CODE_TIMER = 60;

export const RESPONSE_STATUSES = {
  INTERNAL_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  CREATED: 201,
  REQUEST_TIMEOUT: 408,
  UNPROCESSABLE_ENTITY: 422,
};

export const VERIFICATION_OPTIONS = {
  BRANCH: 'branch',
  VIDEO: 'video',
};

export const SUBMIT_TYPES = Object.freeze({
  phone: 'phone',
  email: 'email',
});

export const TRUE_VALUES_FOR_COOKIE_AND_ENV_VARIABLES = [true, 'true', 'TRUE', 1, '1'];

export const APPLICATION_OPERATOR_OFFER_DECREASE = 24;
